export default __webpack_public_path__ + "static/media/ccd32a784abe4bc51459d31d32e5c4f01602169468314.1fbefda2.webp";